<template>
  <section
    class="flex flex-col rounded-md border border-light-gray p-4 text-left"
  >
    <h1 class="text-dark-blue">Affiliations</h1>
    <p class="mt-2 text-xs text-body-color">
      Industry affiliations bolster credibility and expertise.
    </p>
    <section v-if="hasAffiliations">
      <div class="mt-4 flex flex-col gap-2">
        <AffiliationCard
          v-if="tia"
          logo-src="tia"
          label="Member"
          :is-verified="tia"
          custom-logo-class="h-5 w-11"
        />
        <AffiliationCard
          v-if="triumphPay"
          logo-src="triumphPay"
          label="Customer"
          :is-verified="triumphPay"
          custom-logo-class="-ml-2 -mt-1 w-28 h-7"
        />
        <AffiliationCard
          v-if="highway"
          logo-src="highway"
          label="Customer"
          :is-verified="highway"
          custom-logo-class="w-20"
        />
      </div>
    </section>
    <section
      v-else
      class="mt-4 flex h-full flex-col items-center justify-center gap-3 rounded-md border border-light-gray bg-off-white p-4"
      style="min-height: 172px"
    >
      <div class="flex items-center gap-2">
        <h1 class="text-base text-body-color">Unknown</h1>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14 7.39062C14 11.2566 10.866 14.3906 7 14.3906C3.13401 14.3906 0 11.2566 0 7.39062C0 3.52463 3.13401 0.390625 7 0.390625C10.866 0.390625 14 3.52463 14 7.39062ZM7.0595 2.52351C7.95291 2.47575 8.83717 2.7773 9.41463 3.52435C9.93112 4.19252 9.92621 4.95515 9.75864 5.55618C9.5962 6.1388 9.26307 6.66291 8.9475 7.05733L8.40562 7.7346C8.14305 8.06278 8 8.47056 8 8.89085H6C6 8.01638 6.29764 7.16795 6.84395 6.48513L7.38583 5.80785C7.6097 5.52804 7.76901 5.24541 7.83212 5.01904C7.88813 4.81813 7.84687 4.76598 7.83356 4.74915L7.83227 4.74751C7.73732 4.62468 7.54762 4.50027 7.16628 4.52066C6.77252 4.54172 6.22037 4.72535 5.59999 5.19062L4.40001 3.59061C5.25515 2.94927 6.17852 2.57062 7.0595 2.52351ZM5.99992 10.1363V12.3495H7.99992V10.1363H5.99992Z"
            fill="#A9ADBD"
          />
        </svg>
      </div>
    </section>
  </section>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import AffiliationCard from '@/components/show/reusable/AffiliationCard.vue';

const props = defineProps({
  affiliations: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

const tia = computed(() => props.affiliations?.tia_member || false);
const triumphPay = computed(() => props.affiliations?.triumph_pay || false);
const highway = computed(() => props.affiliations?.highway_member || false);
const hasAffiliations = computed(
  () => tia.value || triumphPay.value || highway.value
);
</script>
